/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { isElement, isHTMLElement } from "@adapptio/lib-shared";

import * as attributes from "../DragAndDrop/dragAndDropAttributes";

const attrPrefix = "data-floating-panel";

const borderAttr = `${attrPrefix}-border`;

export const floatingPanelBorderProps = {
	[borderAttr]: true
};

const floatingPanelBorderSelector = `[${borderAttr}]`;

const dragHandleAttr = `${attrPrefix}-handle`;

export const floatingPanelDragHandleProps = {
	[dragHandleAttr]: true
};

const floatingPanelDragHandleSelector = `[${dragHandleAttr}]`;

export function findClosestFloatingPanelBorder(input: MouseEvent | TouchEvent | HTMLElement): HTMLElement {
	const target = isHTMLElement(input) ? input : input?.target;

	if (!isElement(target)) {
		return document?.body;
	}

	const handle = target?.closest(floatingPanelBorderSelector);

	if (isHTMLElement(handle)) {
		return handle;
	}

	return document?.body;
}

export function findClosestFloatingPanelDragHandle(
	input: MouseEvent | TouchEvent | HTMLElement
): HTMLElement {
	const target = isHTMLElement(input) ? input : input?.target;

	if (!isElement(target)) {
		return null;
	}

	const handle = target?.closest(floatingPanelDragHandleSelector);

	if (!isHTMLElement(handle)) {
		return null;
	}

	return handle;
}

export function findNestedFloatingPanelDragHandle(panelElement: HTMLElement): HTMLElement {
	if (!isHTMLElement(panelElement)) {
		return null;
	}

	return panelElement.querySelector(floatingPanelDragHandleSelector);
}
